import deDE from 'antd/locale/de_DE';
import enUS from 'antd/locale/en_US';
import hrHR from 'antd/locale/hr_HR';

import 'moment/locale/hr';
import 'moment/locale/de';
import 'dayjs/locale/hr';
import 'dayjs/locale/de';

export const getAntdLocale = () => {
  const language = localStorage.getItem('i18nextLng') || 'hr';

  switch (language) {
    case 'en':
      return enUS;
    case 'de':
      return deDE;
    case 'hr':
      return hrHR;
    default:
      return hrHR;
  }
};
